import { chakraCreateIcon as createIcon } from "@airhelp/react-ui-components";

export const BarcodeScannerIcon = createIcon({
  displayName: "barcodeScannerIcon",
  viewBox: "0 0 40 40",
  path: (
    <svg>
      <g id="filter_center_focus_24px">
        <rect rx="4" fill="#FFFFFF" />
        <path
          id="icon/image/filter_center_focus_24px"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6667 14.5C13.6667 14.0417 14.0417 13.6667 14.5 13.6667H16.1667C16.625 13.6667 17 13.2917 17 12.8333C17 12.375 16.625 12 16.1667 12H13.6667C12.75 12 12 12.75 12 13.6667V16.1667C12 16.625 12.375 17 12.8333 17C13.2917 17 13.6667 16.625 13.6667 16.1667V14.5ZM12.8333 22C12.375 22 12 22.375 12 22.8333V25.3333C12 26.25 12.75 27 13.6667 27H16.1667C16.625 27 17 26.625 17 26.1667C17 25.7083 16.625 25.3333 16.1667 25.3333H14.5C14.0417 25.3333 13.6667 24.9583 13.6667 24.5V22.8333C13.6667 22.375 13.2917 22 12.8333 22ZM22.8333 12H25.3333C26.25 12 27 12.75 27 13.6667V16.1667C27 16.625 26.625 17 26.1667 17C25.7083 17 25.3333 16.625 25.3333 16.1667V14.5C25.3333 14.0417 24.9583 13.6667 24.5 13.6667H22.8333C22.375 13.6667 22 13.2917 22 12.8333C22 12.375 22.375 12 22.8333 12ZM25.3333 24.5C25.3333 24.9583 24.9583 25.3333 24.5 25.3333H22.8333C22.375 25.3333 22 25.7083 22 26.1667C22 26.625 22.375 27 22.8333 27H25.3333C26.25 27 27 26.25 27 25.3333V22.8333C27 22.375 26.625 22 26.1667 22C25.7083 22 25.3333 22.375 25.3333 22.8333V24.5ZM17 19.5C17 18.1167 18.1167 17 19.5 17C20.8833 17 22 18.1167 22 19.5C22 20.8833 20.8833 22 19.5 22C18.1167 22 17 20.8833 17 19.5Z"
          fill="#0D73FF"
        />
      </g>
    </svg>
  ),
});
